import { isProd } from '@/lib/utils';
import { isSingapore } from './const';
const defaultConfig = {
  app_id: 'M69',
  single_page: true,
  product_id: '165871791400000080',
  server_url: isProd ? 'https://sdklog.linghitai.com' : 'https://sandbox-sdklog.linghitai.com',
};
export const bigDataInit = () => {
  let initConfig = defaultConfig;
  let timer: any = null;
  let trackInit = () => {
    clearTimeout(timer);
    if (window.sense) {
      window.sense.init(initConfig);
    } else {
      timer = setTimeout(trackInit, 10);
    }
  };
  !isSingapore && trackInit();
};
export default bigDataInit;
